import { render, staticRenderFns } from "./manage-ps.vue?vue&type=template&id=23570369"
import script from "./manage-ps.vue?vue&type=script&lang=js"
export * from "./manage-ps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports